export type DurationOption = {
  value: number;
  label: string;
};

export const formatDurationLabel = (minutes?: number): string => {
  if (minutes == null) {
    return "";
  }

  const totalMinutes = Math.max(0, Math.floor(minutes));
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  if (hours === 0) {
    return `${mins} min`;
  }

  if (mins === 0) {
    return `${hours}h`;
  }

  return `${hours}h${String(mins).padStart(2, "0")}`;
};

export const buildDurationOptions = (
  maxMinutes: number,
  stepMinutes = 15
): DurationOption[] => {
  const totalSteps = Math.floor(maxMinutes / stepMinutes);

  return Array.from({ length: totalSteps }, (_, index) => {
    const minutes = (index + 1) * stepMinutes;

    return {
      value: minutes,
      label: formatDurationLabel(minutes),
    };
  });
};
